export enum ModeratorType {
	None,
	Normal,
	Admin,
}

export enum ModeratorUpdateType {
	Init,
	Add,
	Remove,
}

export interface Moderator {
	email: string
	type: ModeratorType
}

export type ModeratorUpdateInit = {
	type: ModeratorUpdateType.Init
	moderators: Moderator[]
}

export type ModeratorUpdateAdd = {
	type: ModeratorUpdateType.Add
	moderators: Moderator[]
}

export type ModeratorUpdateRemove = {
	type: ModeratorUpdateType.Remove
	moderators: string[]
}
